<template>
  <div>
    <app-spinner v-if="!schedule_rental" />
    <template v-else>
      <app-schedule :schedule="schedule_rental" />
    </template>
  </div>
</template>

<script>
import AppSchedule from '@/components/AppSchedule'

export default {
  name: 'TransferScheduleRental',
  components: { AppSchedule },
  props: {
    schedule_rental: Object
  },
}
</script>
